import { render, staticRenderFns } from "./Scheduled Posts.vue?vue&type=template&id=5ab608ff&"
import script from "./Scheduled Posts.vue?vue&type=script&lang=js&"
export * from "./Scheduled Posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports